import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SelectOption } from "components/dropdown/Dropdown";
import LanguageDropdown from "components/LanguageDropdown/LanguageDropdown";
import englishFlag from "assets/en-GB.png";

type FooterProps = {
  hideFooter: boolean;
};

const SHOW_LEFT_CONTAINER = false;
const SHOW_SOCIAL_LINKS = false;
const SHOW_PAGE_LINKS = false;
const SHOW_LANGUAGE_SELECTOR = false;

const Footer: React.FC<FooterProps> = ({ hideFooter }) => {
  const year = new Date().getFullYear();
  const [language, setLanguage] = useState<SelectOption | null>();

  const languageOptions = [
    {
      value: 1,
      label: "English",
      data: { image: englishFlag },
    },
  ];

  if (hideFooter) {
    return null;
  }

  return (
    <footer
      className={`FooterPublic ${
        !SHOW_LEFT_CONTAINER ? "LeftContainerHidden" : ""
      }`}
    >
      {SHOW_LEFT_CONTAINER && (
        <div className="FooterPublicLeftContainer">
          {SHOW_SOCIAL_LINKS && (
            <div className="FooterPublicSocialIcons">
              <a
                href="http://localhost:3000/sign-in"
                target="_blank"
                rel="noopener noreferrer"
                className="FooterPublicSocialIcon Facebook"
              >
                {""}
              </a>

              <a
                href="https://twitter.com/avamaelondon"
                target="_blank"
                rel="noopener noreferrer"
                className="FooterPublicSocialIcon Twitter"
              >
                {""}
              </a>

              <a
                href="https://www.instagram.com/avamaelondon/"
                target="_blank"
                rel="noopener noreferrer"
                className="FooterPublicSocialIcon Instagram"
              >
                {""}
              </a>
            </div>
          )}

          {SHOW_PAGE_LINKS && (
            <div className="FooterPublicLinks">
              <div className="FooterPublicLink">
                <Link to="/terms-and-conditions">
                  <span>Terms and conditions</span>
                </Link>
              </div>

              <div className="FooterPublicLink">
                <Link to="/privacy-policy">
                  <span>Privacy poilicy</span>
                </Link>
              </div>

              <div className="FooterPublicLink">
                <Link to="/site-map">
                  <span>Site map</span>
                </Link>
              </div>

              <div className="FooterPublicLink">
                <span>Turn on accessibility mode</span>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="FooterPublicRightContainer">
        {SHOW_LANGUAGE_SELECTOR && (
          <div className="FooterPublicLanguageSelect">
            <LanguageDropdown
              value={languageOptions[0]}
              options={languageOptions}
              onChange={(selectedOption: any) => {
                setLanguage(selectedOption);
              }}
            />
          </div>
        )}

        <p className="FooterPublicText">
          Copyright &copy;{year} Principle All rights reserved. | Website
          development by{" "}
          <span className="FooterPublicTextSpan">
            AVAMAE Software Solutions Ltd.
          </span>
        </p>
      </div>
    </footer>
  );
};

export { Footer };
